import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-6">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>
        
        <h1 className="font-heading text-3xl font-bold text-foreground mb-2">Terms of Service</h1>
        <p className="text-muted-foreground mb-8">Last updated: January 2026</p>
        
        <div className="prose prose-green dark:prose-invert max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-foreground">1. Agreement to Terms</h2>
            <p className="text-muted-foreground">
              By accessing or using Fencepost, you agree to be bound by these Terms of Service. 
              If you do not agree, please do not use the app.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">2. Description of Service</h2>
            <p className="text-muted-foreground">
              Fencepost is a farm planning and tracking tool that provides:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Daily task overview and checklists</li>
              <li>Weather alerts and forecasts</li>
              <li>Crop and garden planning tools</li>
              <li>Livestock and poultry management</li>
              <li>Market price tracking</li>
              <li>Notes and chat features</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">3. Subscription & Pricing</h2>
            <p className="text-muted-foreground">
              Fencepost is offered on three plans, all after a 7-day free trial:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2" data-testid="tos-pricing-list">
              <li><strong>Monthly plan:</strong> $9.99 per month.</li>
              <li><strong>Annual plan:</strong> $99 per year (approx. $8.25/month equivalent).</li>
              <li>
                <strong>Founding-rate plan:</strong> $79 per year — a promotional
                annual rate offered to early supporters for a limited time. Once
                claimed, the founding rate renews at $79/year for as long as the
                subscription remains active and uninterrupted; if it lapses, the
                founding rate is no longer available and renewals convert to the
                then-current $99/year annual price.
              </li>
            </ul>
            <p className="text-muted-foreground mt-3">
              <strong>Billing:</strong> Subscriptions are billed through Stripe on the cadence of the plan you select (monthly or annually).<br />
              <strong>Cancellation:</strong> You may cancel at any time. Access continues until the end of your current billing period.<br />
              <strong>Refunds:</strong> Monthly plans include a 30-day money-back guarantee from your initial subscription date, no questions asked. Annual and founding-rate plans remain eligible for a full refund within 14 days of your initial subscription if you&apos;re unsatisfied.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">4. User Responsibilities</h2>
            <p className="text-muted-foreground">You agree to:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Provide accurate account information</li>
              <li>Keep your login credentials secure</li>
              <li>Use the service for lawful purposes only</li>
              <li>Not attempt to reverse engineer or hack the service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">5. Content Disclaimer</h2>
            <p className="text-muted-foreground">
              Fencepost provides planning tools and suggestions for informational purposes. All content 
              should be considered guidance only. Always verify critical decisions 
              with local agricultural experts, extension offices, or veterinarians. We are not liable for 
              decisions made based on information in the app.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">6. Weather & Market Data</h2>
            <p className="text-muted-foreground">
              Weather data is provided by OpenWeatherMap and market prices from various sources including USDA. 
              This data is provided "as-is" and may not reflect real-time conditions. Always verify with 
              official sources for critical decisions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">7. Limitation of Liability</h2>
            <p className="text-muted-foreground">
              Fencepost is provided "as is" without warranties. We are not liable for any damages arising 
              from your use of the service, including but not limited to crop losses, livestock losses, 
              or financial decisions made based on information provided by the app.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">8. Changes to Terms</h2>
            <p className="text-muted-foreground">
              We may update these terms from time to time. Continued use of the service after changes 
              constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground">9. Contact</h2>
            <p className="text-muted-foreground">
              For questions about these terms, contact us at: support@myfencepost.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
